import { render, staticRenderFns } from "./AccessPointsComponent.vue?vue&type=template&id=4088be25&scoped=true"
import script from "./AccessPointsComponent.vue?vue&type=script&lang=js"
export * from "./AccessPointsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4088be25",
  null
  
)

export default component.exports